import React from 'react';
import { COMPANY_NAME } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tip from '../../BuildingBlocks/Tooltip/Tip';

const useStyles = makeStyles((theme) => ({
  onboardingTip: {
    marginTop: ({ marginTop }: any) => {
      return theme.spacing(marginTop);
    },
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}));

const TEXT = `Why does ${COMPANY_NAME} ask for this information?`;

export default function OnboardingToolTip({
  summary = TEXT,
  tooltip,
  marginTop = 4,
}) {
  const classes = useStyles({ marginTop });

  return (
    <div className={classes.onboardingTip}>
      <Tip text={summary} tooltip={tooltip} />
    </div>
  );
}
